export enum ReferralStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
}
